import React from "react";

const NeueAddMapBlockStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.25 7.25V4.75C7.25 4.19772 6.80228 3.75 6.25 3.75H3.75C3.19772 3.75 2.75 4.19772 2.75 4.75V7.25C2.75 7.80228 3.19772 8.25 3.75 8.25H6.25C6.80228 8.25 7.25 7.80228 7.25 7.25Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.75 4.75H17.25",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.75 12.75H17.25",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.75 7.25H17.25",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.75 15.25H17.25",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.40005 15.75L3.82388 16.2301C3.99302 16.4331 4.25646 16.5321 4.5174 16.4908C4.77834 16.4494 4.99829 16.2738 5.09641 16.0285L4.40005 15.75ZM7.20115 12.7587C7.48215 12.4543 7.46315 11.9799 7.15875 11.6989C6.85435 11.4179 6.3799 11.4369 6.09895 11.7413L7.20115 12.7587ZM3.72622 13.7699C3.46104 13.4517 2.98812 13.4087 2.66991 13.6738C2.3517 13.939 2.30871 14.4119 2.57388 14.7301L3.72622 13.7699ZM5.09641 16.0285C5.43871 15.1728 5.96138 14.355 6.41155 13.7398C6.63455 13.4351 6.83495 13.1865 6.97855 13.0152C7.05035 12.9296 7.10765 12.8637 7.14625 12.82C7.16555 12.7981 7.18015 12.7819 7.18945 12.7716C7.19415 12.7664 7.19745 12.7627 7.19945 12.7606C7.20045 12.7595 7.20105 12.7588 7.20135 12.7585C7.20155 12.7583 7.20155 12.7583 7.20155 12.7583L7.20145 12.7584C7.20135 12.7585 7.20135 12.7585 7.20125 12.7586C7.20125 12.7586 7.20115 12.7587 6.65005 12.25C6.09895 11.7413 6.09886 11.7414 6.09877 11.7415C6.09873 11.7415 6.09863 11.7416 6.09855 11.7417C6.0984 11.7419 6.09822 11.7421 6.09802 11.7423C6.09762 11.7427 6.09713 11.7433 6.09655 11.7439C6.09539 11.7452 6.09387 11.7468 6.09199 11.7489C6.08824 11.753 6.08308 11.7587 6.07658 11.7658C6.06357 11.7802 6.0452 11.8007 6.022 11.827C5.97563 11.8795 5.90991 11.9551 5.82931 12.0512C5.6683 12.2432 5.44684 12.5181 5.20103 12.854C4.71372 13.52 4.11139 14.4522 3.70369 15.4715L5.09641 16.0285ZM2.57388 14.7301L3.82388 16.2301L4.97622 15.2699L3.72622 13.7699L2.57388 14.7301Z",
  fill: "currentColor"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(NeueAddMapBlockStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;